import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaFilePdf } from "react-icons/fa";

import banner1 from "../assets/admision_matricula/admision/Admision-2025.jpg";
import banner2 from "../assets/admision_matricula/admision/Arquitectura1.jpg";
import banner3 from "../assets/admision_matricula/admision/Arquitectura2.jpg";
import banner4 from "../assets/admision_matricula/admision/contabilidad1.jpg";
import banner5 from "../assets/admision_matricula/admision/contabilidad2.jpg";
import banner6 from "../assets/admision_matricula/admision/enfermeria1.jpg";
import banner7 from "../assets/admision_matricula/admision/enfermeria2.jpg";
import banner8 from "../assets/admision_matricula/admision/farmacia1.jpg";
import banner9 from "../assets/admision_matricula/admision/farmacia2.jpg";
import banner10 from "../assets/admision_matricula/admision/mecatronica1.jpg";
import banner11 from "../assets/admision_matricula/admision/mecatronica2.jpg";

// PDFs locales
import pdfRequisitos from "../assets/admision_matricula/admision/Requisitos.pdf";
import pdfVacantes from "../assets/admision_matricula/admision/vacantes.pdf";
import pdfNumeroVacantes from "../assets/admision_matricula/admision/numeroVacantes.pdf";
import pdfCronograma from "../assets/admision_matricula/admision/cronograma.pdf";

//  PDFs Resultados
import resArqDiurno from "../assets/admision_matricula/admision/APD.pdf";
import resArqNocturno from "../assets/admision_matricula/admision/APN.pdf";
import resContaDiurno from "../assets/admision_matricula/admision/COD.pdf";
import resContaNocturno from "../assets/admision_matricula/admision/CON.pdf";
import resEnferDiurno from "../assets/admision_matricula/admision/ETD.pdf";
import resEnferNocturno from "../assets/admision_matricula/admision/ETN.pdf";
import resMecaDiurno from "../assets/admision_matricula/admision/MAD.pdf";
import resMecaNocturno from "../assets/admision_matricula/admision/MAN.pdf";
import resFarDiurno from "../assets/admision_matricula/admision/FTD.pdf";
import resFarNocturno from "../assets/admision_matricula/admision/FTN.pdf";

import "./Admision.css";

const banners = [
  banner1, banner2, banner3, banner4, banner5, banner6,
  banner7, banner8, banner9, banner10, banner11
];

const Admision = () => {
  const [index, setIndex] = useState(0);
  const [fullscreenImg, setFullscreenImg] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % banners.length);
    }, 5000);
    return () => clearInterval(id);
  }, []);

  const prev = () => setIndex((i) => (i - 1 + banners.length) % banners.length);
  const next = () => setIndex((i) => (i + 1) % banners.length);
  const abrirPDF = (pdf) => setSelectedPdf(pdf);
  const cerrarPDF = () => setSelectedPdf(null);

  const documentos = [
    { titulo: "Requisitos y Costos", pdf: pdfRequisitos },
    { titulo: "Vacantes", pdf: pdfVacantes },
    { titulo: "Número de Vacantes", pdf: pdfNumeroVacantes },
    { titulo: "Cronograma", pdf: pdfCronograma },
  ];

  const resultados = [
    { titulo: "Arquitectura de Plataformas y Servicios TI - Diurno", pdf: resArqDiurno },
    { titulo: "Arquitectura de Plataformas y Servicios TI - Nocturno", pdf: resArqNocturno },
    { titulo: "Contabilidad - Diurno", pdf: resContaDiurno },
    { titulo: "Contabilidad - Nocturno", pdf: resContaNocturno },
    { titulo: "Enfermería Técnica - Diurno", pdf: resEnferDiurno },
    { titulo: "Enfermería Técnica - Nocturno", pdf: resEnferNocturno },
    { titulo: "Mecatrónica Automotriz - Diurno", pdf: resMecaDiurno },
    { titulo: "Mecatrónica Automotriz - Nocturno", pdf: resMecaNocturno },
    { titulo: "Técnica en Farmacia - Diurno", pdf: resFarDiurno },
    { titulo: "Técnica en Farmacia - Nocturno", pdf: resFarNocturno },
  ];

  return (
    <section className="admision-page">
      {/*  Banner superior */}
      <div className="info-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Admisión 2025</h1>
          <p className="lead">
            Ven y estudia los Programas de Estudios que tenemos para ti.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container py-5">
        <div className="row align-items-start">
       
          <div className="col-lg-6 col-md-12" data-aos="fade-right">
            <h2 className="section-subtitle mb-4">Modalidades de Admisión</h2>
            <p className="text-muted mb-4">
              El Proceso de Admisión del Instituto de Educación Superior
              Tecnológico Público <strong>“Juan Velasco Alvarado”</strong>{" "}
              comprende las siguientes modalidades:
            </p>

            <div className="modalidad">
              <h5 className="fw-bold text-primary">a. Ordinaria:</h5>
              <p>Se realiza periódicamente a través de una evaluación considerando condiciones de calidad...</p>
            </div>
            <div className="modalidad">
              <h5 className="fw-bold text-primary">b. Por Exoneración:</h5>
              <p>Contempla la Admisión a deportistas calificados, estudiantes talentosos o servicio militar voluntario.</p>
            </div>
            <div className="modalidad">
              <h5 className="fw-bold text-primary">c. Por Ingreso Extraordinario:</h5>
              <p>Proceso autorizado por el MINEDU para becas y programas especiales, según normativa vigente.</p>
            </div>

            <div className="mt-4 text-start">
              <a
                href="https://drive.google.com/file/d/1j3AgR0zE6zpGUjzYF5Qfq7undcYNUnng/view"
                target="_blank" rel="noopener noreferrer"
                className="btn-descargar" data-aos="zoom-in"
              >
                📄 Descargar Prospecto 2025
              </a>
            </div>
          </div>

          {/*  Slider de banners */}
          <div className="col-lg-6 col-md-12 mt-5 mt-lg-0" data-aos="fade-left">
            <div className="banner-slider-container">
              <div className="banner-slider">
                {banners.map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt={`Banner ${i + 1}`}
                    className={i === index ? "active" : ""}
                    onClick={() => setFullscreenImg(src)}
                  />
                ))}
              </div>
              <button className="banner-arrow left" onClick={prev}>&#10094;</button>
              <button className="banner-arrow right" onClick={next}>&#10095;</button>
            </div>
          </div>
        </div>

        {/*  Sección de PDFs */}
        <div className="admision-pdfs mt-5" data-aos="fade-up">
          <h2 className="text-center section-subtitle mb-5">Requisitos, Costos y Vacantes</h2>
          <div className="row g-4 justify-content-center">
            {documentos.map((doc, i) => (
              <div key={i} className="col-md-3 col-sm-6 d-flex justify-content-center">
                <div className="pdf-card text-center" onClick={() => abrirPDF(doc.pdf)}>
                  <div className="pdf-icon"><FaFilePdf size={50} color="#9d2d2dff" /></div>
                  <p className="pdf-titulo mt-3">{doc.titulo}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/*  Sección de Resultados */}
     
            <div className="admision-pdfs mt-5" data-aos="fade-up">
            <h2 className="text-center section-subtitle mb-3">
                RESULTADOS DEL EXAMEN DE ADMISIÓN 2025
            </h2>
            <p className="text-center text-muted mb-5">
                Clic 👇 para ver los resultados por programa
            </p>

            <div className="row g-4 justify-content-center">
                {resultados.map((res, i) => (
                <div key={i} className="col-md-3 col-sm-6 d-flex justify-content-center">
                    <div
                    className="pdf-card text-center"
                    onClick={() => abrirPDF(res.pdf)}
                    >
                    <div className="pdf-icon">
                        <FaFilePdf size={50} color="#9d2d2dff" />
                    </div>
                    <p className="pdf-titulo mt-3">{res.titulo}</p>
                    </div>
                </div>
                ))}
            </div>
            </div>

      </div>

      {/*  Modal PDF */}
      {selectedPdf && (
        <div className="pdf-modal" onClick={cerrarPDF}>
          <div className="pdf-modal-content-wide" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={cerrarPDF}>✕</button>
            <iframe src={`${selectedPdf}#view=FitH`} title="Vista PDF" className="pdf-full-view-wide"></iframe>
          </div>
        </div>
      )}

      
      {fullscreenImg && (
        <div className="fullscreen-overlay" onClick={() => setFullscreenImg(null)}>
          <img src={fullscreenImg} alt="Ampliado" className="fullscreen-img" />
        </div>
      )}
    </section>
  );
};

export default Admision;
